import React from 'react';
import useStore from '@/stores/useStore';
import DevMenuModal from './DevMenuModal';
import { IS_WEB } from '@/shared/constants/utility';
import PostCallModal from './PostCallModal';
import AppVersionModal from './AppVersionModal';
import SnackBar from '../SnackBar';

const Portals = () => {
  const { snackbarState, clearSnackBar } = useStore();

  return (
    <>
      {!IS_WEB && <DevMenuModal />}
      {!IS_WEB && <AppVersionModal />}

      <PostCallModal />

      <SnackBar
        visible={snackbarState.open}
        onDismiss={clearSnackBar}
        message={snackbarState.message}
        severity={snackbarState.severity}
      />
    </>
  );
};

export default Portals;
